import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CounterComponent } from './components/counter/counter.component';
import { LogComponent } from './components/log/log.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material-module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalComponent } from './components/modal/modal.component';
import { OutsideClickDirective } from './directives/outside-click.directive';
import { TokenComponent } from './components/cards-engine/components/card/components/token/token.component';
import { CardComponent } from './components/cards-engine/components/card/card.component';
import { CardsEngineComponent } from './components/cards-engine/cards-engine.component';
import { LockBoardComponent } from './components/lock-board/lock-board.component';
import { TextBlockComponent } from './components/text-blocks/text-block/text-block.component';
import { TextBlockCitationComponent } from './components/text-blocks/text-block-citation/text-block-citation.component';
import { LinkSharingComponent } from './components/text-blocks/link-sharing/link-sharing.component';
import { CardOutlineComponent } from './components/text-blocks/card-outline/card-outline.component';
import { TextSectionTitleComponent } from './components/text-blocks/text-section-title/text-section-title.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { TabRoomComponent } from './components/tabs/components/tab-room/tab-room.component';
import { HubService } from './services/hub.service';
import { PreviewBlockComponent } from './components/text-blocks/preview-block/preview-block.component';
import { PlayerTagComponent } from './components/player-tag/player-tag.component';
import { BlankContainerComponent } from './components/text-blocks/blank-container/blank-container.component';
import { NewsComponent } from './components/news/news.component';
import { CardFocusComponent } from './components/cards-engine/components/card-focus/card-focus.component';
import { TextBannerComponent } from './components/text-blocks/text-banner/text-banner.component';
import { PwaOfflineIndicatorComponent } from './components/pwa-offline-indicator/pwa-offline-indicator.component';
import { PlayerService } from './services/player.service';
import { TextWarningComponent } from './components/text-blocks/text-warning/text-warning.component';
import { AvailableContentComponent } from './components/text-blocks/available-content/available-content.component';
// import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ReactiveFormsModule
    // MatSnackBarModule
  ],
  declarations: [
    CardComponent,
    CounterComponent,
    TokenComponent,
    LogComponent,
    ModalComponent,
    OutsideClickDirective,
    CardsEngineComponent,
    LockBoardComponent,
    LockBoardComponent,
    TextBlockComponent,
    TextBlockCitationComponent,
    LinkSharingComponent,
    CardOutlineComponent,
    TextSectionTitleComponent,
    TabsComponent,
    TabRoomComponent,
    PreviewBlockComponent,
    PlayerTagComponent,
    BlankContainerComponent,
    NewsComponent,
    CardFocusComponent,
    TextBannerComponent,
    PwaOfflineIndicatorComponent,
    TextWarningComponent,
    AvailableContentComponent
  ],
  entryComponents: [],
  exports: [
    CardsEngineComponent,
    CardComponent,
    CounterComponent,
    TokenComponent,
    LogComponent,
    LockBoardComponent,
    ModalComponent,
    TextBlockComponent,
    TextBlockCitationComponent,
    LinkSharingComponent,
    CardOutlineComponent,
    TextSectionTitleComponent,
    TabsComponent,
    TabRoomComponent,
    PreviewBlockComponent,
    PlayerTagComponent,
    BlankContainerComponent,
    NewsComponent,
    CardFocusComponent,
    TextBannerComponent,
    PwaOfflineIndicatorComponent,
    TextWarningComponent,
    AvailableContentComponent
  ],
  providers: [HubService, PlayerService]
})
export class SharedModule {}
